<h2 mat-dialog-title>Inserimento Utente</h2>
<hr>
<form [formGroup]="insertUserForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="container" id="insert-container">
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Username*:</mat-label>
                <input matInput type="text" formControlName="username">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Email*:</mat-label>
                <input matInput type="email" formControlName="email">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Password*:</mat-label>
                <input matInput type="text" formControlName="password">
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions id="action-div">
        <button mat-stroked-button (click)="closeCancelling()" type="button">Annulla</button>
        <button mat-stroked-button color="primary" type="submit" [disabled]="!insertUserForm.valid">Inserisci</button>
    </mat-dialog-actions>
</form>